export const stringToJson = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return undefined;
  }
};

export default stringToJson;
